import {
  selectedDepartureVar,
  selectedReturnVar,
} from '../../operations/localState/reactiveVariables';
import { getCookies } from '../common';

export const getMarketingAirlineCodesFromFlight = (flight) => {
  const marketingAirlineCodes = [];
  if (flight && flight.flightSegments)
    flight.flightSegments.forEach(({ marketingAirline }) => {
      if (
        marketingAirline &&
        marketingAirline.code &&
        !marketingAirlineCodes.some(
          (savedMarketingAirlineCode) => savedMarketingAirlineCode === marketingAirline.code,
        )
      ) {
        marketingAirlineCodes.push(marketingAirline.code);
      }
    });
  return marketingAirlineCodes.join('-');
};

const getProductObject = (
  flightOriginAirport,
  flightDestinationAirport,
  returnCabin,
  departureFlight,
  returnFlight,
) => {
  return {
    flightProdCost: (returnCabin && returnCabin.totalPrice && returnCabin.totalPrice.value) || '',
    flightProdCategory: 'Flight',
    flightDepartureDate: (departureFlight && departureFlight.departDate) || '',
    flightReturnDate: (returnFlight && returnFlight.arrivalDate) || '',
    flightProdSku: `${flightOriginAirport}-${flightDestinationAirport}-${flightDestinationAirport}-${flightOriginAirport}`,
    returnAirlineCode: getMarketingAirlineCodesFromFlight(returnFlight),
    flightDestination: flightDestinationAirport,
    departureAirlineCode: getMarketingAirlineCodesFromFlight(departureFlight),
  };
};

export const buildCommonProductObject = (shouldIncludeProdQuantity = false) => {
  const selectedDeparture = selectedDepartureVar();
  const selectedReturn = selectedReturnVar();
  const departureFlight = selectedDeparture && selectedDeparture.flight;
  const departureSegments = (departureFlight && departureFlight.flightSegments) || [];
  const returnCabin = selectedReturn && selectedReturn.cabin;
  const returnFlight = selectedReturn && selectedReturn.flight;
  const flightOriginAirport = departureSegments.length
    ? departureSegments[0].departure.airport.code
    : '';
  const departureSegmentsMaxIndex = departureSegments.length - 1;
  const flightDestinationAirport =
    departureSegmentsMaxIndex > -1
      ? departureSegments[departureSegmentsMaxIndex].arrival.airport.code
      : '';
  const productObject = getProductObject(
    flightOriginAirport,
    flightDestinationAirport,
    returnCabin,
    departureFlight,
    returnFlight,
  );

  return shouldIncludeProdQuantity
    ? {
        ...productObject,
        flightProdQuantity: (returnCabin && returnCabin.passengerQty) || '',
      }
    : productObject;
};

export function getSplitExManageRes() {
  const segment =
    getCookies && typeof getCookies === 'function' ? getCookies('manage_segment') : null;
  if (segment === 'experiment') {
    return 'Experiment';
  }
  if (segment === 'control') {
    return 'Control';
  }
  return undefined;
}
